<div class="row">
    <div class="col">
        <div class="block" [id]="idName"></div>
    </div>
</div>

